import Vue from "vue";
import VueRouter from "vue-router";
import memberLayout from "@/views/layout/memberLayout";
import noneLayout from "@/views/layout/noneLayout";
import guestLayout from "@/views/layout/guestLayout";
import notAuthLayout from "@/views/layout/notAuthLayout";
import voucherLayout from "@/views/layout/voucherLayout";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("@/views/main/index"),
    name: "main",
    hidden: true
  },
  {
    path: "/scanContractNum",
    component: notAuthLayout,
    children: [
      {
        path: "",
        component: () => import("@/views/verify/scanContractNum"),
        name: "scanContractNum",
        hidden: true
      }
    ]
  },
  // 요금제 페이지
  {
    path: "/paymentInfo",
    component: () => import("@/views/main/payment"),
    name: "paymentInfo",
    hidden: true
  },
  {
    path: "/v2",
    component: () => import("@/views/main/index"),
    name: "main2",
    hidden: true
  },
  {
    path: "/v2/contractLock",
    component: () => import("@/views/contractLock/index"),
    name: "lock",
    hidden: true
  },
  {
    path: "/login",
    component: noneLayout,
    children: [
      {
        path: "/login",
        component: () => import("@/views/login/index"),
        name: "login",
        hidden: true
      }
    ]
  },
  {
    path: "/join",
    component: noneLayout,
    children: [
      {
        path: "/join",
        component: () => import("@/views/join/index"),
        name: "join",
        hidden: true
      },
      {
        path: "/authConfirm",
        component: () => import("@/views/join/authConfirm"),
        name: "authConfirm",
        hidden: true
      },
      {
        path: "/usrSwJoinAuthConfirm",
        component: () => import("@/views/join/usrSwJoinAuthConfirm"),
        name: "usrSwJoinAuthConfirm",
        hidden: true
      }
    ]
  },
  {
    path: "/dashboard",
    component: memberLayout,
    children: [
      {
        path: "/main",
        component: () => import("@/views/dashBoard/index"),
        name: "dashboard",
        hidden: true
      }
    ]
  },
  {
    path: "/contract",
    component: memberLayout,
    redirect: "noredirect",
    children: [
      {
        path: "/list",
        component: () => import("@/views/contract/contractList/index"),
        name: "storage",
        hidden: true
      },
      {
        path: "/detail",
        component: () => import("@/views/contract/contractDetail/index"),
        name: "contractDetail",
        props: true,
        hidden: true
      },
      {
        path: "/dongwonDetail",
        component: () =>
          import("@/views/contract/contractDetail/dongwonDetail"),
        name: "contractDongwonDetail",
        props: true,
        hidden: true
      },
      {
        path: "/sajoDetail",
        component: () => import("@/views/contract/contractDetail/sajoDetail"),
        name: "sajoDetail",
        props: true,
        hidden: true
      },
      {
        path: "/write",
        component: () => import("@/views/contract/addNew/index"),
        name: "writeContract",
        hidden: true
      }
    ]
  },
  {
    path: "/contractLock",
    redirect: "noredirect",
    component: guestLayout,
    children: [
      {
        path: "",
        component: () => import("@/views/contractLock/index"),
        hidden: true
      },
      {
        path: "/lockDetail",
        component: () => import("@/views/contractLock/detail"),
        name: "lockDetail",
        props: true,
        hidden: true
      },
      {
        path: "/dongwonLockDetail",
        component: () => import("@/views/contractLock/dongwonLockDetail"),
        name: "dongwonLockDetail",
        props: true,
        hidden: true
      },
      {
        path: "/sajoLockDetail",
        component: () => import("@/views/contractLock/sajoLockDetail"),
        name: "sajoLockDetail",
        props: true,
        hidden: true
      },
      {
        path: "/changeMember",
        component: () => import("@/views/contractLock/changeMember"),
        name: "changeMember",
        props: true,
        hidden: true
      }
    ]
  },
  {
    path: "/fee",
    component: memberLayout,
    children: [
      {
        path: "/feePay",
        component: () => import("@/views/feepay/index"),
        name: "feePay",
        hidden: true
      }
    ]
  },
  // 이벤트
  //   {
  //       path: '/event',
  //       component: noneLayout,
  //       children: [{
  //           path: '',
  //           component: () =>
  //               import ('@/views/dashBoard/event/event01'),
  //           name: 'event',
  //           hidden: true
  //       }]
  //   },
  // 이벤트
  //   {
  //     path: "/event01",
  //     component: () => import("@/views/dashBoard/event/event01"),
  //     name: "event01",
  //     hidden: true
  //   },
  /** OfficeContract */
  {
    path: "/officeContractList",
    component: memberLayout,
    children: [
      {
        path: "",
        component: () => import("@/views/officeContract/officeContractList"),
        name: "officeContractList",
        hidden: true
      }
    ]
  },
  {
    path: "/createOfficeContract",
    component: memberLayout,
    children: [
      {
        path: "",
        component: () => import("@/views/officeContract/contractCompany/index"),
        name: "createOfficeContract",
        hidden: true
      }
    ]
  },
  /** Settings */
  {
    path: "/orgConfig",
    component: memberLayout,
    children: [
      {
        path: "",
        component: () => import("@/views/setting/orgConfig"),
        name: "orgConfig",
        hidden: true
      }
    ]
  },
  {
    path: "/scontract",
    component: memberLayout,
    children: [
      {
        path: "",
        component: () => import("@/views/setting/contract"),
        name: "scontract",
        hidden: true
      }
    ]
  },
  {
    path: "/chain",
    component: memberLayout,
    children: [
      {
        path: "",
        component: () => import("@/views/setting/chain"),
        name: "chain",
        hidden: true
      }
    ]
  },
  {
    path: "/verify",
    component: memberLayout,
    children: [
      {
        path: "/verify",
        component: () => import("@/views/verify/index"),
        name: "verify",
        hidden: true
      }
    ]
  },
  {
    path: "/crew",
    component: memberLayout,
    children: [
      {
        path: "",
        component: () => import("@/views/setting/crew"),
        name: "crew",
        hidden: true
      }
    ]
  },
  {
    path: "/companyAuth",
    component: memberLayout,
    children: [
      {
        path: "",
        component: () => import("@/views/company/auth/index"),
        name: "auth",
        hidden: true
      }
    ]
  },
  // 비대면 바우처 관리자
  {
    path: "/voucher",
    component: voucherLayout,
    children: [
      {
        path: "",
        component: () => import("@/views/voucher/login"),
        hidden: true
      }
    ]
  },
  {
    path: "/voucherLog",
    component: voucherLayout,
    children: [
      {
        path: "",
        component: () => import("@/views/voucher/voucherLog"),
        name: "voucherLog",
        hidden: true,
        props: true
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: routes
});

export default router;
